import { Typography, Grid, Button  } from "@mui/material"
import CheckCircleIcon from '@mui/icons-material/CheckCircle';


const CustomFormSuccess = ({handleClose, message})=>{
    return (
        <Grid container direction="column" justifyContent="center" alignItems="center" sx={{ minHeight: '200px' }}>
        <Grid item>
            <CheckCircleIcon sx={{ fontSize: 80, color: 'green' }} />  
        </Grid>
        <Grid item>
            <Typography variant="h6" sx={{ mt: 2, textAlign: "center" }}>
                {message}
            </Typography>
        </Grid>
        <Grid item>
            <Typography variant="h6" sx={{ mt: 2 }}>
                <Button onClick={handleClose}>Close</Button>
            </Typography>
        </Grid>
    </Grid>
    )
}

export default CustomFormSuccess